<template>
  <div>
    <v-speed-dial v-model="fab" direction="right" absolute open-on-hover>
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <slot> </slot>
      <v-btn fab dark small color="red" @click="onDelete" v-if="!hideDelete">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-delete</v-icon>
          </template>
          Remove Selected Records
        </v-tooltip>
      </v-btn>
    </v-speed-dial>
    <v-dialog v-model="showRemoveConfirmationDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>
        <v-card-text> This will remove all selected records. </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="warning"
            text
            @click.native="showRemoveConfirmationDialog = false"
            >No</v-btn
          >
          <v-btn color="primary" @click="onConfirm">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfirmationDialog from "../ConfirmationDialog";
export default {
  name: "simple-list-actions",
  props: {
    hideDelete: {
      type: Boolean,
      default: () => false,
    },
  },
  components: { ConfirmationDialog },

  data() {
    return {
      fab: false,
      showRemoveConfirmationDialog: false,
    };
  },

  methods: {
    onDelete() {
      this.showRemoveConfirmationDialog = true;
    },
    onConfirm() {
      this.showRemoveConfirmationDialog = false;
      this.$emit("delete");
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/list-actions/SimpleListActions.vue